import { getAllAmbulanceEmployeeMapping } from "../../apis/ambulance";
import { ambulanceEmployeeMappingApi } from "../../apis/mapping";
import { getAllAmbulanceEmployeeFailure, getAllAmbulanceEmployeeSuccess, addAmbulanceEmployeeFailure,
  addAmbulanceEmployeeSuccess, editAmbulanceEmployeeFailure, editAmbulanceEmployeeSuccess,
  deleteAmbulanceEmployeeFailure, deleteAmbulanceEmployeeSuccess
 } from "../constants/ambulanceEmployeeMapping";
 import { showNotification } from "./notification";

function getAllAmbulanceEmployee(payload) {
  return ({type: getAllAmbulanceEmployeeSuccess, payload: payload})
}

function getAllAmbulanceEmployeeError() {
  return ({type: getAllAmbulanceEmployeeFailure})
}

function editCrewSuccess(employeeList, ambulanceId) {
  debugger
  return {
    type: editAmbulanceEmployeeSuccess,
    payload: {
      ambulanceId,
      employeeList
    }
  };
}
function editCrewFailure() {
  return ({type: editAmbulanceEmployeeFailure})
}

export function getAllAmbulanceMappings(query) {
  return ((dispatch) => {
    getAllAmbulanceEmployeeMapping(query).then(
      (res) => {
        if (res) {
          dispatch(getAllAmbulanceEmployee(res));
        }
      },
      (error) => {
        dispatch(getAllAmbulanceEmployeeError());
      }
    )
  })
}

export function editAmbulanceMappings(query, ambulanceId) {
  return ((dispatch) => {
    ambulanceEmployeeMappingApi(query).then(
      (res) => {
        if (res.length > 0) {
          dispatch(editCrewSuccess(res, ambulanceId));
        }
        dispatch(showNotification({
          type: "success",
          message: "Success",
          description: "Employees Mapped Successfully"
        }))
      },
      (error) => {
        dispatch(editCrewFailure());
        dispatch(showNotification({
          type: "error",
          message: "Unable to Map the Employee(s)",
          description: error?.message
        }))
      })
  })
  
}